import {
	Button,
	ConfirmationDialog,
	DrawerRight,
	LabelField,
	Loading,
	TextField,
	Trackers,
} from 'src/components';
import { Grid, MenuItem } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import InstructionsDialog from './InstructionsDialog';

import { type ICourse } from 'src/models';
import { type RootState } from 'src/store';
import { useDispatch, useSelector } from 'react-redux';
import courseActions from 'src/store/Courses/actions';

interface Props {
	open: boolean;
	onClose: () => void;
	courseId?: number;
	from: 'list' | 'edition';
}

function DrawerForm({ courseId, from = 'list', onClose, open }: Props) {
	// NOTE: Ver todas las notas de ./src/modules/private/Admin.tsx
	const dispatch = useDispatch();
	const { course, isLoadingOne } = useSelector(
		(state: RootState) => state.courses,
	);
	const create = (course: ICourse) => dispatch(courseActions.create(course));
	const update = (course: ICourse) => dispatch(courseActions.update(course));
	const clearInstitution = () => dispatch(courseActions.setOne({}));
	const [dialoOpen, setDialogOpen] = useState(false);
	const [removeConfirmation, setRemoveConfirmation] = useState(false);

	const { handleChange, handleReset, handleSubmit, values } = useFormik({
		enableReinitialize: true,
		initialValues: courseId ? course : { name: '' },
		onSubmit: (values) => {
			if (courseId) update(values);
			else create(values);
			onClose();
		},
	});

	useEffect(() => {
		if (!open) {
			handleReset({});
			if (from === 'list') clearInstitution();
		}
	}, [open, courseId]);

	return (
		<DrawerRight
			onClose={onClose}
			open={open}
			title={`${courseId ? 'Editar' : 'Crear'} Curso`}
		>
			<Loading isLoading={isLoadingOne}>
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<TextField
							label={'Nombre'}
							name={'name'}
							onChange={handleChange}
							value={values.name}
						/>
					</Grid>

					{Boolean(courseId) && (
						<>
							<Grid item xs={12}>
								<LabelField
									label={'Total de secciones'}
									value={values.totalSections}
								/>
							</Grid>

							<Grid item xs={12}>
								<LabelField
									label={'Total de preguntas'}
									value={values.totalQuestions}
								/>
							</Grid>

							<Grid item xs={12}>
								<LabelField
									label={'Total de preguntas en examen'}
									value={values.totalExamQuestions}
								/>
							</Grid>

							<Grid item style={{ marginTop: 16 }} xs={12}>
								<TextField
									label={'Calificación mínima'}
									name={'minimumQualification'}
									onChange={handleChange}
									value={values.minimumQualification}
								/>
							</Grid>

							<Grid item xs={12}>
								<TextField
									label={'Máximo de intentos'}
									name={'maxAttempts'}
									onChange={handleChange}
									value={values.maxAttempts}
								/>
							</Grid>

							<Grid item xs={12}>
								<TextField
									label={'Tipo de examen'}
									name={'exam'}
									onChange={handleChange}
									select
									value={values.exam}
								>
									<MenuItem value={'global'}>
										{' '}
										Global{' '}
									</MenuItem>

									<MenuItem value={'partial'}>
										{' '}
										Parcial{' '}
									</MenuItem>
								</TextField>
							</Grid>

							<Grid item xs={12}>
								<Button
									actionType={'edit'}
									backgroundColor={'white'}
									fullWidth
									onClick={() => {
										setDialogOpen(true);
									}}
								>
									instrucciones de examen
								</Button>
							</Grid>

							<InstructionsDialog
								courseId={courseId || 0}
								handleOpen={() => {
									setDialogOpen(false);
								}}
								instructions={values.instructions}
								open={dialoOpen}
							/>
						</>
					)}

					{Boolean(courseId) && <Trackers model={course} />}

					<Grid item xs={12}>
						<Button
							actionType={'save'}
							fullWidth
							onClick={() => {
								handleSubmit();
							}}
						>
							{courseId ? 'Guardar Cambios' : 'Crear'}
						</Button>
					</Grid>

					{Boolean(courseId) && (
						<>
							<Grid item xs={12}>
								<Button
									actionType="remove"
									backgroundColor={'white'}
									fullWidth
									onClick={() => {
										setRemoveConfirmation(true);
									}}
								>
									Eliminar
								</Button>
							</Grid>

							<ConfirmationDialog
								open={removeConfirmation}
								title={`¿Deseas eliminar el curso "${values.name}"?`}
								onClose={() => {
									setRemoveConfirmation(false);
								}}
								onConfirm={() => {
									dispatch(courseActions.remove(courseId!));
									setRemoveConfirmation(false);
									onClose();
								}}
							/>
						</>
					)}

				</Grid>
			</Loading>
		</DrawerRight>
	);
}

export default DrawerForm;
